export function accordion() {
  return {
    MuiAccordion: {},
    MuiAccordionSummary: {},
  };
}
